/**
 * Entfernungen in der Sprache des Nutzers.
 *
 * Seemeilen sind an Bord das Maß, aber die App wird auch von Leuten benutzt, die erst
 * anfangen und Kilometer besser einschätzen können. Unter einem Kilometer zählt ohnehin
 * der Meter, weil "0,05 sm" niemandem etwas sagt.
 */
import { NM_IN_METERS } from './geometry'
import type { Units } from './settings'

export const KM_IN_METERS = 1000

export function nmToKm(nm: number): number {
  return (nm * NM_IN_METERS) / KM_IN_METERS
}

export function formatDistance(nm: number, units: Units = 'nm'): string {
  const meters = nm * NM_IN_METERS
  if (meters < KM_IN_METERS) return `${Math.round(meters / 10) * 10} m`
  return units === 'km' ? `${nmToKm(nm).toFixed(2)} km` : `${nm.toFixed(2)} sm`
}
